var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImportWizardTable',{attrs:{"content-rows":_vm.mappedData.rows,"content-headers":_vm.mappedData.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }